<template>
    <div class="">
         
         <div class="columns">
						<div class="column">
							<div class="">
                                <b-field horizontal label="Diagnosis Note">
                                    <b-input type="textarea" v-model="diagnosisNoteModel"></b-input>
                                </b-field>

                                <b-field horizontal label="Result Remark">
                                    <b-input type="textarea" v-model="resultRemarkModel"></b-input>
                                </b-field>



                                <!-- <b-field horizontal label="Significance Phy.">
                                    <b-input type="textarea" v-model="singni_phyModel"></b-input>
                                </b-field>
                                <b-field horizontal label="Test Desire">
                                    <b-input type="textarea" v-model="test_desireModel"></b-input>
                                </b-field>
                                <b-field horizontal label="Special Rq.">
                                    <b-input type="textarea" v-model="special_rqModel"></b-input>
                                </b-field> -->
                            </div>
						</div>
						<div class="column">
							<div class="">
                                 <b-field horizontal label="Tentative Dx.">
                                    <b-input type="textarea"  v-model="tentative_dxModel"></b-input>
                                </b-field>
                                <b-field horizontal label="Comment">
                                    <b-input type="textarea" v-model="commentNoteModel"></b-input>
                                </b-field>
                            </div>
						</div>

                                     
					</div> 
                <div class="columns">
						<div class="column">
                        <b-field horizontal label="DVM Req.">
                             <b-autocomplete
                                v-model="userAutoComplete_Model"
                                :data="filteredUser"
                                placeholder="e.g. วิจิตร/กนกวรรณ/สมหมาย"
                                icon="magnify"
                                :open-on-focus=true
                                clearable
                                field="full_name"
                                @input = "newTypingAutocompleteUser"
                                @select="option => (userSelecteddModel = option)"
                                >
                                <template slot="empty">No results found</template>
                        </b-autocomplete>




                        </b-field>
                        </div>
                        <div class="column">
                        </div>
                </div>            
                    

                    

             <!-- <b-field horizontal label="Comment">
                 <b-input type="textarea"></b-input>
             </b-field> -->



             <hr>
             <CBC_Images 
                
             />

    </div>
</template>

<script>
import { mapState , mapMutations  } from "vuex";
import CBC_Images from './CBC_Images.vue'

export default {
    name : "OtherParam",
    components:{
        CBC_Images
    },
    computed:{
            ...mapState({
                access_token : state => state.master_data.access_token,
                commentNote : state => state.manually_create_lab_automate.commentNote , 
                singni_phy: state => state.manually_create_lab_automate.singni_phy , 
                tentative_dx: state => state.manually_create_lab_automate.tentative_dx , 
                test_desire: state => state.manually_create_lab_automate.test_desire , 
                special_rq: state => state.manually_create_lab_automate.special_rq ,

                diagnosisNote: state => state.manually_create_lab_automate.diagnosisNote ,
                resultRemark : state => state.manually_create_lab_automate.resultRemark ,

                // arrDVM: state => state.manually_create_lab_automate.arrDVM , 
                // dvmSelected: state => state.manually_create_lab_automate.dvmSelected , 
                // dvmAutocomplete: state => state.manually_create_lab_automate.dvmAutocomplete , 

                arrUsers: state => state.manually_create_lab_automate.arrUsers , 
                userSelected: state => state.manually_create_lab_automate.userSelected , 
                userAutoComplete: state => state.manually_create_lab_automate.userAutoComplete , 



            }),
         
            diagnosisNoteModel:{
                get: function(){
                     return   this.diagnosisNote
                },
                set: function(newValue){
                     this.setDiagnosisNote(newValue)
                }
            }, 


            resultRemarkModel:{
                get: function(){
                     return   this.resultRemark
                },
                set: function(newValue){
                     this.setResultRemark(newValue)
                }
            }, 



            userAutoComplete_Model:{
                get: function(){
                     return   this.userAutoComplete
                },
                set: function(newValue){
                     this.set_userAutocomplete(newValue)
                }
            },  
            userSelecteddModel:{
                get: function () {
                    return this.userSelected
                },
                set: function (newValue) {
                    this.setUserSelected(newValue)
                }
            } ,
            arrUsers_Model:{
                get: function () {
                    return this.arrUsers
                },
                set: function (newValue) {
                    this.setArrUsers(newValue)
                }
            } ,



            // dvmAutocomplete_Model:{
            //     get: function(){
            //          return   this.dvmAutocomplete
            //     },
            //     set: function(newValue){
            //          this.set_dvmAutocomplete(newValue)
            //     }
            // },  
            // arrDVMSelectedModel:{
            //     get: function () {
            //         return this.dvmSelected
            //     },
            //     set: function (newValue) {
            //         this.setDVMSelected(newValue)
            //     }
            // } ,



            // arrDVM_Model:{
            //     get: function () {
            //         return this.arrDVM
            //     },
            //     set: function (newValue) {
            //         this.setArrDVM(newValue)
            //     }
            // } ,


            commentNoteModel:{
                get: function () {
                    return this.commentNote
                },
                set: function (newValue) {
                    this.setCommentNote(newValue)
                }
            },
            
            singni_phyModel:{
                get: function () {
                    return this.singni_phy
                },
                set: function (newValue) {
                    this.setSingni_phy(newValue)
                }
            },

            tentative_dxModel:{
                get: function () {
                    return this.tentative_dx
                },
                set: function (newValue) {
                    this.setTentative_dx(newValue)
                }
            },


            test_desireModel:{
                get: function () {
                    return this.test_desire
                },
                set: function (newValue) {
                    this.setTest_desire(newValue)
                }
            },

            special_rqModel:{
                get: function () {
                    return this.special_rq
                },
                set: function (newValue) {
                    this.setSpecial_rq(newValue)
                }
            },


            //  filteredDVM(){
            //      return this.arrDVM_Model.filter((_dvm => {
                     
            //         return  _dvm.full_name
            //                 .toString()
            //                 .toUpperCase()
            //                 .indexOf(this.dvmAutocomplete_Model.toUpperCase()) >= 0
            //     }))
             
            // },


            filteredUser(){
                 return this.arrUsers_Model.filter((_user => {
                     
                    return  _user.full_name
                            .toString()
                            .toUpperCase()
                            .indexOf(this.userAutoComplete_Model.toUpperCase()) >= 0
                }))
             
            },



    },
    methods:{
         ...mapMutations({
            setCommentNote : 'manually_create_lab_automate/setCommentNote' ,
            setSingni_phy : 'manually_create_lab_automate/setSingni_phy' ,
            setTentative_dx : 'manually_create_lab_automate/setTentative_dx' ,
            setTest_desire : 'manually_create_lab_automate/setTest_desire' ,
            setSpecial_rq : 'manually_create_lab_automate/setSpecial_rq' ,


            setDiagnosisNote: 'manually_create_lab_automate/setDiagnosisNote' ,
            setResultRemark: 'manually_create_lab_automate/setResultRemark' ,

            // setArrDVM: 'manually_create_lab_automate/setArrDVM' ,
            // setDVMSelected: 'manually_create_lab_automate/setDVMSelected' ,
            // set_dvmAutocomplete: 'manually_create_lab_automate/set_dvmAutocomplete' ,
            setArrUsers: 'manually_create_lab_automate/setArrUsers' ,
            setUserSelected: 'manually_create_lab_automate/setUserSelected' ,
            set_userAutocomplete: 'manually_create_lab_automate/set_userAutocomplete' ,
        }),


       
        // newTypingAutocompleteDVM(){
           
        //     const memberDVM = this.arrDVM_Model.find(memberDVM => memberDVM.full_name === this.dvmAutocomplete_Model  )
        //             if(memberDVM){
        //                 this.arrDVMSelectedModel = memberDVM.iduser
        //             }else{
        //                 this.arrDVMSelectedModel = null
        //     }
        // }, 

        newTypingAutocompleteUser(){
           
            const member = this.arrUsers_Model.find(member => member.full_name === this.userAutoComplete_Model  )
                    if(member){
                        this.userSelecteddModel = member.iduser
                    }else{
                        this.userSelecteddModel = null
            }
        }, 


    },
    data(){
        return{
          
        }
    }       
}
</script>